import {Scheduler} from "./Scheduler";
import {slideTo} from "./functions";

$('.services-page .header-section .main-image img').on('img2svg:replaced', function() {
    let $el = $(this).parent().find('svg');
    $el.find('path[fill="#111"]')
        .addClass('path-services')
        .end()
        .find('path[fill="#FFF"]')
        .addClass('svg-draw-bg-services')
        .css('fill', 'transparent');
});

let $ServiceAnimations = $('.service-animation');

$ServiceAnimations.find('path, rect, circle, line')
    .each(function() {
        let $t = $(this);
        if ($t.closest('.no-animate').length > 0 || $t.hasClass('.no-animate')) {
            return;
        }
        var length = this.getTotalLength();
        $t.addClass('path-service').css({
            'stroke-dasharray': length,
            'stroke-dashoffset': length,
            'fill': 'transparent',
            'stroke': '#111111',
            'stroke-width': '3px'
        });
    });

Scheduler.add(() => {
    $('.path-service').each(function() {
        let $e = $(this),
            fill = $e.attr('fill'),
            width = $e.attr('stroke-width'),
            stroke = $e.attr('stroke'),
            $outer = $e.closest('[fill]');
        if (fill === undefined) {
            fill = 'transparent';

            if ($outer.length > 0) {
                fill = $outer.attr('fill');
            }
        }
        if (width === undefined) {
            width = '1px';
        }
        if (stroke === undefined) {
            stroke = 'transparent';
        }
        $e.css({
            'transition': 'fill 1s, stroke 1s, stroke-width 1s',
            'fill': fill,
            'stroke': stroke,
            'stroke-width': width
        });
    });
}, this, 3500);


$('.services-page .big-icon-box[data-section]').on('click', function(event) {
    event.preventDefault();
    var sectionId = $(this).attr('data-section');

    slideTo($('.services-section[data-section-id="' + sectionId + '"]'), 120);
});
